module.exports = __webpack_public_path__ + "51ca837cffb1cf53f51c96c8c75a5185.svg";